// extracted by css-extract-rspack-plugin
export default {"markdownRoot":"VvvrT","lineClamp":"pAzZ4","tableScroll":"Psbbc"};